module.exports = __webpack_public_path__ + "img/m.ed166401.jpg";